@let readOnly = $readOnly();

<form [formGroup]="formGroup">
  <div class="x-card x-card_size_m x-white card-shadow">
    <p class="x-island-header">
      {{ 'request_form.common.car.title' | translate }}
    </p>

    <div class="x-input-label">
      {{ 'request_form.common.car.car_brand_id' | translate }}
    </div>
    <x-form-picker
      [formControlName]="FormFields.CarBrandId"
      [readOnly]="readOnly"
      xAttachCarBrands
    ></x-form-picker>

    <div class="x-input-label">
      {{ 'request_form.common.car.car_model' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.CarModel"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.car.car_type' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.CarType"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.car.VIN' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.VIN"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.car.car_plant_number' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.CarPlantNumber"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.car.car_year' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          tuiInputYear
          [formControlName]="FormFields.CarYear"
          [min]="carMinYear"
          [max]="carMaxYear"
          [readOnly]="readOnly"
        />
        <tui-calendar-year *tuiDropdown />
      </tui-textfield>
    </div>

    <div class="x-input-label">
      {{ 'request_form.common.car.manufacturer_country' | translate }}
    </div>
    <div>
      <tui-textfield tuiTextfieldSize="m">
        <input
          [formControlName]="FormFields.ManufacturerCountry"
          tuiInput
          [readOnly]="readOnly"
        />
      </tui-textfield>
    </div>
  </div>
</form>
